<template>
  <div id="app">
    <v-app style="background: #383F61;">
      <Header></Header>
      <router-view class="px-1"></router-view>
      <Footer></Footer>
    </v-app>
  </div>
</template>


<script>
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import {mapState} from 'vuex';

export default {
name: 'app',
components: {
  Footer,
  Header
},

computed: {
  ...mapState(['username']),

},


watch:{

  username () {
    this.$store.dispatch('init_total_info');
    this.$store.dispatch('init_aver');
  }

},

created: function() {
  this.$store.dispatch('init_total_info');
  this.$store.dispatch('init_aver');
  this.$store.dispatch('init_settings');
}
}
</script>